var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 9,
    viewBox: "0 0 17 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.557019 0.760367C0.558647 0.58088 0.626401 0.401994 0.769387 0.26158C1.04583 -0.00988778 1.49927 -0.00577395 1.77073 0.270665L7.87408 6.48576C8.3234 6.94331 9.06024 6.94999 9.51779 6.50067L15.7329 0.397336C16.0093 0.125868 16.4628 0.129982 16.7342 0.406421C17.0057 0.682859 17.0016 1.1363 16.7251 1.40777L10.5101 7.5111C10.0239 7.98851 9.3696 8.25655 8.67999 8.25029C7.99039 8.24403 7.34097 7.97361 6.86364 7.47802L0.760302 1.26293C0.629334 1.12003 0.555391 0.939853 0.557019 0.760367Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.c9b1dfb0986a47d7c4e0c2d0a9fcc71c.svg";
export { ForwardRef as ReactComponent };